import { render } from "./user.vue?vue&type=template&id=a54ce248&scoped=true"
const script = {}

import "./user.vue?vue&type=style&index=0&id=a54ce248&lang=scss&scoped=true"

import exportComponent from "D:\\yunchi\\yc\\yc-vue-source\\new-energy\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a54ce248"]])

export default __exports__